const trackerMixin = {
  data: () => ({
    mixinSessionId: undefined,
    sessionStorageKey: 'vegas_session_id',
  }),
  methods: {
    mixinGenerateSessionId() {
      const generateRandomBetween = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;

      const timestamp = Date.now();
      const randomNumber = generateRandomBetween(1000, 9999);
      const userId = window.USER.id;

      const sessionId = `${timestamp}${randomNumber}${userId}`;
      this.mixinSessionId = sessionId;

      window.localStorage.setItem(this.sessionStorageKey, sessionId);
    },
    // objective: re-sync session_id on localStorage. Call it on lifecycle: created
    mixinSyncSessionId() {
      try {
        const isNotReload = JSON.parse(JSON.stringify(performance.getEntriesByType('navigation')[0])).type !== 'reload';
        const sessionId = window.localStorage.getItem(this.sessionStorageKey);

        if (isNotReload || !sessionId) this.mixinGenerateSessionId();
        else this.mixinSessionId = sessionId;
      } catch (error) {
        this.mixinGenerateSessionId();
      }
    },
  },
};

export default trackerMixin;
